import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

export const mondayEmbedOrigin = "https://view.monday.com";

export const mondayCookie: CookieService<CookieCategory.FEATURES> = {
  category: CookieCategory.FEATURES,
  iframe: {
    embedUrl: `${mondayEmbedOrigin}/embed/{data-id}?r=use1`,
    label: "Pour voir",
  },
  name: "Monday",
  privacyPolicyUrl: "https://monday.com/l/privacy/privacy-policy/",
  purpose: "Contenus, formulaires et cartes interactives",
};
